import { Box, Snackbar } from "@mui/material";
import { useContext, useEffect, useReducer, useState } from "react";
import { DateTime } from "luxon";
import { useAppSelector } from "hooks";
import { debugState } from "redux/slices/debug";
import { WebStoreContext } from "../../contexts/WebStoreProvider";

const DebugClock = (): JSX.Element | null => {
	const { nowTime } = useContext(WebStoreContext);
	const { showClock } = useAppSelector(debugState);
	const [showCopiedMessage, setShowCopiedMessage] = useState(false);
	// nowTime is mutated in place every second, so force a re-render to read it
	const [, tick] = useReducer((n: number) => n + 1, 0);

	useEffect(() => {
		if (!showClock) {
			return;
		}
		const intervalId = window.setInterval(tick, 1000);
		return () => window.clearInterval(intervalId);
	}, [showClock]);

	if (!nowTime || !showClock) {
		return null;
	}

	const pacificTime = DateTime.fromMillis(nowTime.valueOf())
		.setZone("America/Los_Angeles")
		.toFormat("yyyy-MM-dd HH:mm:ss");

	const handleCopyTime = async () => {
		try {
			await navigator.clipboard.writeText(pacificTime);
			setShowCopiedMessage(true);
		} catch (error) {
			console.warn("Unable to copy the current time", error);
		}
	};

	return (
		<>
			<Box
				component="button"
				type="button"
				aria-label="Copy current time to clipboard"
				title="Click to copy"
				onClick={handleCopyTime}
				sx={{
					position: "fixed",
					top: 0,
					// vw ignores the scrollbar, so the clock doesn't shift when a drawer locks the scroll
					left: "50vw",
					transform: "translateX(-50%)",
					zIndex: 1202,
					px: 1,
					py: 0.5,
					border: 0,
					borderRadius: "0 0 8px 8px",
					backgroundColor: "rgb(179, 0, 255)",
					color: "#fff",
					fontFamily: "inherit",
					fontSize: 11,
					fontWeight: 600,
					lineHeight: 1.4,
					fontVariantNumeric: "tabular-nums",
					cursor: "pointer",
					"@media(max-width: 765px)": {
						px: 0.8,
						py: 0.1,
						fontSize: 10
					}
				}}
			>
				{pacificTime} PT
			</Box>
			<Snackbar
				open={showCopiedMessage}
				autoHideDuration={1600}
				anchorOrigin={{ vertical: "top", horizontal: "center" }}
				message="Time copied to clipboard"
				onClose={() => setShowCopiedMessage(false)}
			/>
		</>
	);
};

export default DebugClock;
